import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between w-full" }
const _hoisted_2 = {
  id: "logo-section",
  class: "cursor-pointer py-5 flex-grow max-w-fit w-10/12 sm:w-10/12 lg:w-4/12 truncate"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-arrow-left",
    style: {"font-size":"1rem","color":"#26577b"}
  })
], -1)
const _hoisted_5 = {
  key: 0,
  id: "items-logged-section",
  class: "hidden max-w-full w-8/12 xl:flex items-end flex-row justify-center mx-4"
}
const _hoisted_6 = { class: "flex justify-center max-h-fit gap-3 lg:gap-5" }
const _hoisted_7 = { class: "pb-2 truncate" }
const _hoisted_8 = {
  id: "dropdown-section",
  class: "flex justify-end max-w-fit w-2/12"
}
const _hoisted_9 = {
  id: "logged-items",
  class: "hidden xl:flex items-center"
}
const _hoisted_10 = { class: "flex gap-3 items-center w-40" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  id: "dropdown-section-mobile",
  class: "flex items-center justify-between sm:flex xl:hidden ml-2",
  "aria-controls": "top-nav",
  "aria-expanded": "false",
  "data-collapse-toggle": "top-nav"
}
const _hoisted_14 = { class: "flex gap-4" }
const _hoisted_15 = { class: "flex gap-1 items-center w-8 h-8" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "flex flex-col justify-center w-full gap-x-5" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: _normalizeClass(`${
      _ctx.meta.topbarCollapse() ? ' md:fixed' : ' '
    } flex justify-center gap-3 px-4 bg-white border-gray-200 dark:bg-gray-900 sticky w-full z-50 top-0 left-0 shadow-sm`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("a", {
            class: "text-lg capitalize dark:text-white font-[700] md:flex flex-row gap-2 items-center justify-start",
            title: 
            _ctx.getCourseName(_ctx.$route.params.courseName) ??
            _ctx.$t('labels.generic', { pt: 'Curso', en: 'Course' })
          ,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectToPage('dashboardStd')))
          }, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.getCourseName(_ctx.$route.params.courseName) ??
            _ctx.$t("labels.generic", { pt: "Curso", en: "Course" })), 1)
          ], 8, _hoisted_3)
        ]),
        (_ctx.navItems().length != 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems(), (item, i) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    class: _normalizeClass(`flex`),
                    key: i
                  }, [
                    _createVNode(_component_router_link, {
                      class: _normalizeClass([
                { active: item.name === _ctx.routeName },
                {
                  active:
                    item.groupRouteFrom &&
                    _ctx.$route.meta.groupRouteFrom === item.groupRouteFrom,
                },
              ]),
                      to: { name: item.name }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("li", _hoisted_7, [
                          _createVNode(_component_Button, {
                            class: "btn-simple",
                            onClick: item.command
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: item.icon,
                                class: "text-primary-400 mr-2"
                              }, null, 8, ["name"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", { pt: item.label, en: item.labelEN })), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "to"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                class: "rounded-full object-cover w-12 h-12 bg-gray-50",
                src: 
                _ctx.actualUser?.photoProfile || require('@/assets/images/user.svg')
              ,
                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
                alt: "user"
              }, null, 40, _hoisted_11),
              _createElementVNode("p", {
                class: "btn-simple w-32 truncate cursor-pointer capitalize",
                "aria-haspopup": "true",
                "aria-controls": "overlay_menu",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                title: _ctx.actualUser?.firstName
              }, _toDisplayString(_ctx.actualUser?.firstName), 9, _hoisted_12)
            ]),
            _createVNode(_component_Menu, {
              id: "overlay_menu",
              ref: "menu",
              model: _ctx.dropdownItems(),
              popup: true
            }, null, 8, ["model"])
          ])
        ]),
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                class: "rounded-full object-cover w-8 h-8 cursor-pointer",
                src: 
                _ctx.actualUser?.photoProfile || require('@/assets/images/user.svg')
              ,
                onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
                alt: "user",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
              }, null, 40, _hoisted_16)
            ]),
            _createVNode(_component_Menu, {
              id: "overlay_menu",
              ref: "menu",
              model: _ctx.dropdownItems(),
              popup: true
            }, null, 8, ["model"])
          ]),
          _createVNode(_component_Button, {
            icon: "pi pi-align-right",
            class: "btn-simple",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSidebar = true))
          })
        ])
      ])
    ], 2),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showSidebar,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showSidebar) = $event)),
      baseZIndex: 10000,
      position: "right"
    }, {
      default: _withCtx(() => [
        (_ctx.navItems().length != 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems(), (item, i) => {
                  return (_openBlock(), _createElementBlock("ul", { key: i }, [
                    _createElementVNode("li", {
                      class: "bg-h-primary-100 rounded-md border mb-2 active:bg-h-secondary-100",
                      onClick: ($event: any) => (_ctx.handleMobileClick(item.command))
                    }, [
                      _createVNode(_component_Button, {
                        label: 
                _ctx.$t('labels.generic', { pt: item.label, en: item.labelEN })
              ,
                        icon: "pi pi-angle-right",
                        class: "btn-simple p-button-sm"
                      }, null, 8, ["label"])
                    ], 8, _hoisted_19)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}